import { Heart } from 'lucide-react';
import VideoPlayer from './VideoPlayer';
import React, { useState } from 'react';
import axios from 'axios';
import { REACT_APP_UPLOADS } from '../../../constants';

const texts = [
  "Communities driving transparent wildlife conservation through data.",
  "Join us in making a difference.",
  "Together, we can protect our planet.",
];

interface SummaryProps {
  totalRecords?: number,
  concludedCases?: number,
  speciesTypes?: number
}

export default function Hero() {
  const [currentText, setCurrentText] = React.useState(texts[0]);

  const [data, setData] = useState<SummaryProps>({
    totalRecords: 0,
    concludedCases: 0,
    speciesTypes: 0
  });

  React.useEffect(() => {
              axios.get(`${REACT_APP_UPLOADS}/api/v1/seizure-cases/summary`, {
                headers: {
                  "ngrok-skip-browser-warning": "true"
                }
              }).then(function(res){
              if(res.status === 200){
                  console.log(res);
                  setData(res.data);
              } else {
                  console.log("Error fetching data", res.data?.message);
              }
          }).catch(function(){
              console.log("An error occured")
          })
  }, []);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentText((prevText) => {
        const currentIndex = texts.indexOf(prevText);
        const nextIndex = (currentIndex + 1) % texts.length;
        return texts[nextIndex];
      });
    }, 3000); // Change text every 3 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  });

  return (
    <>
    <section className="relative h-full w-full flex flex-wrap md:flex-nowrap justify-between text-white bg-green-600 px-3">
  <div className="flex flex-col md:flex-row items-center justify-between w-full py-8">
    <div className="flex flex-col items-center md:items-start px-4">
      <h1 className="text-4xl font-bold">{data?.totalRecords}</h1>
      <p className="text-lg font-light">Total<span className="font-bold"> Incidents</span> Reported</p>
    </div>
    <div className="hidden md:block border-l border-gray-400 h-16 mx-4"></div>
    <div className="flex flex-col items-center md:items-start px-4">
      <h1 className="text-4xl font-bold">{data?.speciesTypes}</h1>
      <p className="text-lg font-light"><span className="font-bold">Species</span></p>
    </div>
    <div className="hidden md:block border-l border-gray-400 h-16 mx-4"></div>
    <div className="flex flex-col items-center md:items-start px-4">
      <h1 className="text-4xl font-bold">&lt;5%</h1>
      <p className="text-lg font-light">Total<span className="font-bold"> Convictions</span> in seizures of &gt; 500kg</p>
    </div>
  </div>
</section>
</>
  );
  }